import { render, staticRenderFns } from "./VideoEmbed.vue?vue&type=template&id=052eebd2&scoped=true"
import script from "./VideoEmbed.vue?vue&type=script&lang=js"
export * from "./VideoEmbed.vue?vue&type=script&lang=js"
import style0 from "./VideoEmbed.vue?vue&type=style&index=0&id=052eebd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052eebd2",
  null
  
)

export default component.exports